import { useState, useEffect } from "react";

//  Project API
import projectsAPI from "../services/projectsAPI";

const initialState = {
    page: 0,
    results: [],
    total_pages: 0,
    total_results: 0,
};

function shuffleArray(array) {
    for (var i = array.length - 1; i > 0; i--) {
        var j = Math.floor(Math.random() * (i + 1));
        var temp = array[i];
        array[i] = array[j];
        array[j] = temp;
    }
    return array;
}

export const useProjectsFetch = () => {
    const [state, setState] = useState(initialState);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(false);
    const [isLoadingMore, setIsLoadingMore] = useState(false);

    const fetchProjectsAPI = async page => {
        try {
            setLoading(true);
            const projects = await projectsAPI.fetchProjects(page);
            setState(prev => ({
                page: page,
                total_pages: projects.data.total_pages,
                total_results: projects.data.results,
                results:
                    page > 1
                        ? shuffleArray([...prev.results, ...projects.data.data.document])
                        : shuffleArray(projects.data.data.document),
                
            }));
        } catch (error) {
            setError(true);
        }
        setLoading(false);
    };

    useEffect(() => {
        setState(initialState);
        fetchProjectsAPI(1);
    }, []);

    useEffect(() => {
        if (!isLoadingMore) return;

        fetchProjectsAPI(state.page + 1);
        setIsLoadingMore(false);
    }, [isLoadingMore, state.page]);

    return {
        state,
        loading,
        setLoading,
        error,
        setIsLoadingMore,
    };
};
